import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import HeaderThree from "../../../components/header/HeaderThree";
import CopyRightTwo from "../../../components/footer/CopyRightTwo";
import FooterTwo from "../../../components/footer/FooterTwo";
import axios from "axios";
import { API_URL } from "../../../config";
import CaseStudyCard from "../../../components/blog/BlogStyle5";

const CaseStudy = () => {
  const [data, setData] = useState([]);
  useEffect(() => {
    const fetch = async () => {
      try {
        const { data } = await axios.get(
          `${API_URL}/api/case-study/get_casestudy`
        );
        setData(data.allCaseStudy);
      } catch (e) {
        console.log("this error is coming from casestudy get data", e);
      }
    };
    fetch();
  }, []);
  return (
    <div className="main-page-wrapper">
      <Helmet>
        <title>Blog V5 || Deski-Saas & Software React Template</title>
      </Helmet>

      <HeaderThree />

      <div className="fancy-hero-one">
        <div className="container">
          <div className="row">
            <div className="col-xl-9 col-lg-10 m-auto">
              <h1 className="h1-heading " style={{ marginTop: 'revert' }}>Case Studies</h1>
            </div>
            <div className="col-lg-9 m-auto">
              <p className="font-gordita h1-para">
                You will find here our company news and latest update
              </p>
            </div>
          </div>
        </div>
      </div>
      {/* /.fancy-hero-one */}

      {/* =====================================================
            Feature Blog One
        ===================================================== */}

      <div className="container">
        <div className="row">
          <CaseStudyCard data={data} />
        </div>
      </div>

      <footer className="theme-footer-two pt-80 padt">
        <div className="top-footer">
          <div className="container">
            <FooterTwo />
          </div>
        </div>
        <div className="container">
          <div className="bottom-footer-content">
            <CopyRightTwo />
          </div>
        </div>
      </footer>
    </div>
  );
};

export default CaseStudy;
